import { Flex, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;

const Song = ({thumbnail, artist, track}) => {

  return (
    <Flex style={{padding:'0', width:200}}>
      <img src={thumbnail} alt='album-cover' width={'60px'}/>
      <Flex style={{paddingLeft:'10px'}} justify='center' vertical>
        <Text ellipsis={true} style={{width:'220px'}} strong>{track}</Text>
        <Text>{artist}</Text>
      </Flex>
      </Flex>
  );
};

export default Song;